import '../../Styles/App.css';

import { Typography, Box, Button } from '@mui/material';

function Footer() {
    const footerLinkSx = {
        color: 'text.link',
        textDecoration: 'none',
        position: 'relative',
        display: 'inline-block',
        fontWeight: 500,
        letterSpacing: '0.5px',
        transition: 'color 0.3s ease',

        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: -4,
            width: '0%',
            height: '2px',
            backgroundColor: 'primary.main',
            transition: 'width 0.3s ease',
        },

        '&:hover': {
            color: 'text.alt',
        },

        '&:hover::after': {
            width: '100%',
        },
    };

    return (
        <Box
            sx={{
                maxWidth: '100%',
                bgcolor: 'background.alt',
                py: 3,
                px: { xs: 2, sm: 6 },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                }}
            >
                {/* Left - Title */}
                <Typography
                    variant="h6"
                    sx={{
                        color: 'text.main',
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                    }}
                >
                    Riley Clarke
                </Typography>

                {/* Center - Links */}
                <Box
                    sx={{
                        display: 'flex',
                        gap: { xs: 2, sm: 4 },
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                    }}
                >
                    <a href="mailto:24clarkr@gmail.com" style={{ textDecoration: 'none' }}>
                        <Typography sx={footerLinkSx}>Email</Typography>
                    </a>

                    <a
                        href="https://carbonwastaken.itch.io/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <Typography sx={footerLinkSx}>Itch</Typography>
                    </a>

                    <a
                        href="https://www.youtube.com/channel/UCgrywDMG1hTRvezDdgQBJAQ"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <Typography sx={footerLinkSx}>YouTube</Typography>
                    </a>

                    <a
                        href="https://github.com/carbon1337"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <Typography sx={footerLinkSx}>GitHub</Typography>
                    </a>
                </Box>

                {/* Right - Back to Top */}
                <Button
                    onClick={() =>
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                        })
                    }
                    sx={{
                        color: 'text.link',
                        textTransform: 'none',
                        fontWeight: 500,
                        letterSpacing: '0.5px',
                        minWidth: 'auto',

                        '&:hover': {
                            color: 'text.alt',
                            backgroundColor: 'transparent',
                        },
                    }}
                >
                    Back to Top ↑
                </Button>
            </Box>
        </Box>
    );
}

export default Footer;